





























































import {Component, PropSync, Ref} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import AdvertisementApi, {AdSaveForm} from "@/module/ad/AdvertisementApi";
import ConfirmDialog from "@/component/Dialog/confirm-dialog.vue";

@Component({
  components: {ConfirmDialog}
})
export default class AdSaveDialog extends ConfirmDialog {

  protected api = Container.get(AdvertisementApi)

  @Ref()
  protected dialog!: ConfirmDialog

  @PropSync('form')
  private formSync!: AdSaveForm

  protected previewStyle = {
    opacity: 1
  }

  async open() {
    this.dialog.open()
  }
}
